export enum ColumnTypeEnum{
  TextColumn = 'TextColumn',
  DateColumn = 'DateColumn',
  LabelColumn = 'LabelColumn',
  CurrencyColumn = 'CurrencyColumn',
  IconColumn = 'IconColumn',
  ButtonColumn = 'ButtonColumn',
  BooleanColumn = 'BooleanColumn',
  HyperlinkColumn = 'HyperlinkColumn',
  CustomColumn = 'CustomColumn',
}
